import React from "react"
import classnames from "classnames/bind"

import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import styles from "./BannerHome.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag";
import PlayStoreBadge from "./google-play-badge.png";
import AppStoreBadge from "./app-store-badge.png";

const Article = props => {
  return (
    <article className={styles.article + " text-center text-lg-left pr-lg-5"}>
      <h1
        className={classnames(
          styles.title,
          "proxima-nova--bold",
          "fs-30pt",
          "text-white",
          "fs-lg-40pt"
        )}
      >
        <TopTitle content="IDENTITY IN YOUR HANDS" /> THE ASSERTIV MOBILE APP FOR ANDROID AND IOS
      </h1>
      <div className={styles.badgesBar}>
        <OutboundLink target="_blank" href="https://apps.apple.com/us/app/engineid/id1533212495">
          <img src={AppStoreBadge} className={styles.appBadge} />
        </OutboundLink>
        <OutboundLink target="_blank" href="https://play.google.com/store/apps/details?id=com.engineid.mobile">
          <img src={PlayStoreBadge} className={styles.appBadge} />
        </OutboundLink>
      </div>
    </article>
  )
}

export default Article
